import { render, staticRenderFns } from "./searchDic.vue?vue&type=template&id=ab077dc6&scoped=true&"
import script from "./searchDic.vue?vue&type=script&lang=js&"
export * from "./searchDic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab077dc6",
  null
  
)

export default component.exports